import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">

          Python gang | contact: jnnglrlol@gmail.com

      </header>
    </div>
  );
}

export default App;
